import React from "react";
import ReactDOM from "react-dom";
import { motion } from "framer-motion";
import { listVariation, container, rightContent } from "../data/anim";
const Navbar = ({ toggle, setToggle }) => {
  return ReactDOM.createPortal(
    <motion.div
      variants={rightContent}
      initial="hidden"
      animate={!toggle ? "hidden" : "visible"}
      className="portal-container"
    >
      <nav className="nav">
        <ul className="nav-ul">
          <li variants={listVariation}>
            <a href="#home" onClick={() => setToggle(false)}>
              Home
            </a>
          </li>
          <li variants={listVariation}>
            <a href="#about" onClick={() => setToggle(false)}>
              About
            </a>
          </li>
          <li variants={listVariation}>
            <a href="#skills" onClick={() => setToggle(false)}>
              Skills
            </a>
          </li>
          <li variants={listVariation}>
            <a href="#projects" onClick={() => setToggle(false)}>
              Projects
            </a>
          </li>
          <li variants={listVariation}>
            {" "}
            <a href="#contacts" onClick={() => setToggle(false)}>
              Contact
            </a>
          </li>
        </ul>
      </nav>
    </motion.div>,
    document.getElementById("portal")
  );
};

export default Navbar;
